<h3>Your payment was successful!</h3>
<p class="mb-2 text-center">You can login now and we'll be in touch <br>
  regarding training & integration :)</p>
<a mat-flat-button class="btn btn--l btn--primary" href="/sign-in">Login</a>
